import { render, staticRenderFns } from "./BulkTransferForm.vue?vue&type=template&id=6235bf14&"
import script from "./BulkTransferForm.vue?vue&type=script&lang=js&"
export * from "./BulkTransferForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports